// Fixed ambient-sound toggle. Glassmorphism pill, mono label, animated
// equaliser bars when playing. Gently pulses until first interaction to
// invite the visitor to turn on sound. CSS-only entrance/animation.
export default function AudioToggle({ enabled, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      data-cursor=""
      data-testid="audio-toggle-btn"
      aria-pressed={enabled}
      aria-label={enabled ? "Mute ambient sound" : "Play ambient sound"}
      className="audio-toggle fade-up"
      style={{ "--d": "2s" }}
    >
      <span className={`audio-toggle__eq ${enabled ? "is-on" : ""}`} aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
      </span>
      <span className="audio-toggle__label">
        <span className="audio-toggle__caption">Sound</span>
        <span className="audio-toggle__state" data-testid="audio-toggle-state">
          {enabled ? "On" : "Off"}
        </span>
      </span>
      {!enabled && <span className="audio-toggle__pulse" aria-hidden="true" />}
    </button>
  );
}
